import styled from 'styled-components';

import { CFG } from '../../../../../../theme/configurator-tokens';
import { cardHover, cardSwapIn } from '../../../../../../theme/configurator-keyframes';
import { DESIGN } from '../../design.tokens';

export const Card = styled.button`
  position: relative;
  width: 100%;
  /* Three per row, at the tile's three-per-row landscape proportion (107x62). */
  aspect-ratio: 107 / 62;
  cursor: pointer;
  border: 0;
  padding: 0;
  background: transparent;
  /* Match the thumbnail rounding so the shared glow-border hover (cardHover) traces
     the banner's rounded edge. */
  border-radius: 13px;
  /* Fade + rise in on mount — plays when the colour changes and the art-style set is
     swapped for a new one (the list is keyed on the colour, so the tiles remount). */
  ${cardSwapIn}
  ${cardHover}
`;

export const Thumb = styled.span`
  /* Fill the card via absolute positioning (NOT height: 100%): the source art is
     a 1:1 square, so an in-flow image would leak its intrinsic square height and
     override the card's aspect-ratio (making the banner huge/square). Out of flow,
     nothing forces the card's height, so aspect-ratio owns it and the art crops to
     the landscape banner via object-fit: cover. */
  position: absolute;
  inset: 0;
  overflow: hidden;
  border-radius: 13px;
  background: ${DESIGN.styleTile};
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Ring = styled.span`
  pointer-events: none;
  position: absolute;
  inset: -6px;
  border-radius: 18px;
  border: 2.114px solid ${CFG.brand};
`;
